import { useEffect } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { blogPosts } from "../data/blogData";
import Navbar from "../components/Navbar";

export const BlogDetail = () => {
  const { slug, lang } = useParams();

  const post = blogPosts.find(
    (p) => p.es?.slug === slug || p.en?.slug === slug
  );

  useEffect(() => {
    localStorage.setItem("colorFooter", "white");
    localStorage.setItem("colorNav", "color");
    window.scrollTo(0, 0);
  }, []);

  if (!post) return <Navigate to={`/${lang}/blog`} />;

  const currentContent = post[lang];

  if (!currentContent) return <Navigate to={`/${lang}/blog`} />;

  const siteUrl = "https://www.atmnetss.com";
  const urlEs = `${siteUrl}/es/blog/${post.es.slug}`;
  const urlEn = `${siteUrl}/en/blog/${post.en.slug}`;
  const canonical = lang === "es" ? urlEs : urlEn;

  return (
    <div className="bg-white min-h-screen">
      <Helmet>
        <html lang={lang} />
        <title>{currentContent.titulo} | ATM Net</title>
        <meta
          name="description"
          content={currentContent.metaDescripcion || currentContent.descripcion}
        />
        <meta property="og:title" content={currentContent.titulo} />
        <meta
          property="og:description"
          content={currentContent.metaDescripcion || currentContent.descripcion}
        />
        <meta property="og:image" content={currentContent.imagen} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="article" />
        <meta
          property="og:locale"
          content={lang === "es" ? "es_ES" : "en_US"}
        />
        <link rel="canonical" href={canonical} />
        <link rel="alternate" hrefLang="es" href={urlEs} />
        <link rel="alternate" hrefLang="en" href={urlEn} />
        <link rel="alternate" hrefLang="x-default" href={urlEn} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={currentContent.titulo} />
        <meta
          name="twitter:description"
          content={currentContent.metaDescripcion || currentContent.descripcion}
        />
        <meta name="twitter:image" content={currentContent.imagen} />
      </Helmet>
      <Navbar />

      <article className="max-w-4xl mx-auto px-4 py-12">
        {/* Navegación de regreso */}
        <div className="mb-8 mt-10">
          <Link
            to={`/${lang}/blog`}
            className="text-sm font-bold text-blue-600 flex items-center gap-2 hover:underline"
          >
            ← {lang === "es" ? "Volver al Blog" : "Back to Blog"}
          </Link>
        </div>

        <header className="mb-12">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#19235C] leading-tight mb-6">
            {currentContent.titulo}
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed italic border-l-4 border-orange-500 pl-6 mb-10">
            {currentContent.descripcion}
          </p>
          <img
            src={currentContent.imagen}
            alt={currentContent.titulo}
            className="w-full h-[300px] md:h-[500px] object-cover rounded-3xl shadow-2xl"
          />
        </header>

        {/* Cuerpo del Artículo */}
        <div className="prose prose-lg prose-blue max-w-none text-gray-800">
          <div
            className="blog-content-wrapper"
            dangerouslySetInnerHTML={{ __html: currentContent.contenido }}
          />
        </div>
      </article>
    </div>
  );
};
